<template>
  <div>
    <b-progress v-if="$percentage" :variant="variant[0]" height="1.5rem" :max="100">
      <b-progress-bar :value="$percentage" :label="`${$percentage}%`"> </b-progress-bar>
    </b-progress>

    <b-progress v-else :max="100" animated :variant="variant[1]" height="1.5rem">
      <b-progress-bar :value="100">
        <span>Video is preparing to upload, please wait...</span>
      </b-progress-bar>
    </b-progress>
  </div>
</template>

<script>
export default {
  props: {
    percentage: {
      type: [Number, String],
      default: 0
    },
    variant: {
      type: Array,
      default: () => ['success', 'info']
    }
  },

  computed: {
    $percentage: {
      get() {
        return this.percentage;
      },

      set(v) {
        this.$emit('update:percentage', v);
      }
    }
  }
};
</script>
